module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Bold.c3080a11.ttf";